// extracted by mini-css-extract-plugin
export default {"modalHead":"AddClient_modalHead__heBfL","newClientClass":"AddClient_newClientClass__JxW9p","addClientBTN":"AddClient_addClientBTN__9T-gU","btnPrimary":"AddClient_btnPrimary__U5s+8"};